import { SHORTTERMRATE_INIT_SUCCESS, SHORTTERMRATE_INIT_FAIL, SHORTTERMRATE_INIT_LOADING, SHORTTERMRATE_COMMIT_KEY } from '@/store/types'
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // API menu
  menu: {},
  shortTermRate: {
    shortTermRateId: {
      rate: null,
      appDayMth: null,
      noDayMth: null,
      polType: null,
      createdName: null,
      createdDate: null,
      modifiedName: null,
      modifiedDate: null
    }
  }
}

const getters = {
}

const mutations = {
  [SHORTTERMRATE_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [SHORTTERMRATE_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data ? data.menu : null
    state.initErr = []
  },
  [SHORTTERMRATE_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  },
  [SHORTTERMRATE_COMMIT_KEY](state, data) {
    state.shortTermRate.shortTermRateId.shortTermPct = data.shortTermPct
    state.shortTermRate.shortTermRateId.appDayMth = data.appDayMth
    state.shortTermRate.shortTermRateId.noDayMth = data.noDayMth
    state.shortTermRate.shortTermRateId.polType = data.polType
    state.shortTermRate.shortTermRateId.createdName = data.createdName
    state.shortTermRate.shortTermRateId.createdDate = data.createdDate
    state.shortTermRate.shortTermRateId.modifiedName = data.modifiedName
    state.shortTermRate.shortTermRateId.modifiedDate = data.modifiedDate
    state.shortTermRate.shortTermRateId.strMode = data.strMode
  }
}

const actions = {
  async shortTermRateManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.shortTermRateManagement
    commit(SHORTTERMRATE_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu
        }
        commit(SHORTTERMRATE_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(SHORTTERMRATE_INIT_FAIL, extractMessages(error))
      }
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
